module.exports = __webpack_public_path__ + "static/portfolio_gallery_27-910a1a11cd4321dad33cff19816ebd86.jpg";